import DESCRIPTION from './utils/column_description'
import DATA_TYPES_MYSQL from './utils/data_types_mysql'

export default class Column {
    constructor() {
        this.set({})
        // TODO add support for pasing MySQL fks and enums
    }
    set(col={}) {
        return this.parse(col)
    }
    upd(col={}) {
        Object.entries(col)
            .filter(([name, val]) => val !== undefined)
            .forEach(([name, val]) => this[name] = val)
        return this.prepare()
    }
    copy() {
        return {
            name: this.name,
            type: this.type,
            sub1: this.sub1,
            sub2: this.sub2,
            enum: this.enum,
            deft: this.deft,
            comm: this.comm,
            fkName: this.fkName,
            fkTbl: this.fkTbl,
            fkCol: this.fkCol,
            isPk: this.isPk,
            isUnsigned: this.isUnsigned,
            isNotNull: this.isNotNull,
            isNull: this.isNull,
            isUnique: this.isUnique,
            isIncrem: this.isIncrem,
            onUpdate: this.onUpdate,
            onDelete: this.onDelete
        }
    }
    check() {
        const tp = DATA_TYPES_MYSQL[this.type]
        if(!this.name)
            throw `Name should be set`
        if(!this.type)
            throw `Type should be set`
        if(!tp)
            throw `Unknown type "${this.type}"`
        if(this.sub1 !== undefined && tp.sub1 === undefined)
            throw `Sub1 option is not supported for "${this.type}"`
        if(this.sub2 !== undefined && tp.sub2 === undefined)
            throw `Sub2 option is not supported for "${this.type}"`
        if(this.isUnsigned && !tp.unsigned)
            throw `Unsigned option is not supported for "${this.type}"`
        if(this.comm && this.comm.length > 255)
            throw `Comment can not contain more than 255 symbols`
        if(this.isNotNull && this.isNull)
            throw `isNull and isNotNull can not be set at the same time`
        if(
            this.onUpdate &&
            ['CASCADE', 'SET NULL', 'RESTRICT'].indexOf(this.onUpdate) < 0
        )
            throw `Incorrect Update option "${this.onUpdate}"`
        if(
            this.onDelete &&
            ['CASCADE', 'SET NULL', 'RESTRICT'].indexOf(this.onDelete) < 0
        )
            throw `Incorrect Delete option "${this.onDelete}"`
        return this
    }
    prepare() {
        if(this.type)
            this.type = this.type.toUpperCase()
        for(let [name, desc] of Object.entries(DATA_TYPES_MYSQL))
            if(this.type == name)
                break
            else if(desc.syn && desc.syn.indexOf(this.type) >= 0) {
                this.type = name
                break
            }
        return this
    }
    parse(col={}) {
        this.name = col.name
        this.type = col.type
        this.sub1 = col.sub1
        this.sub2 = col.sub2
        this.enum = col.enum
        this.deft = col.deft
        this.comm = col.comm
        this.fkName = col.fkName
        this.fkTbl = col.fkTbl
        this.fkCol = col.fkCol
        this.isPk       = !!col.isPk
        this.isUnsigned = !!col.isUnsigned
        this.isNotNull  = !!col.isNotNull
        this.isNull     = !!col.isNull
        this.isUnique   = !!col.isUnique
        this.isIncrem   = !!col.isIncrem
        this.onUpdate   = col.onUpdate
        this.onDelete   = col.onDelete
        return this.prepare()
    }
    parseMySQL(c) {
        this.name = c.Field
        this.type = c.Type.split(' ')[0].split('(')[0].toUpperCase()
        this.sub1 = c.Type.indexOf('(') >= 0 ? c.Type.split('(')[1].split(')')[0].split(',')[0] : undefined
        this.sub2 = c.Type.indexOf('(') >= 0 && c.Type.indexOf(',') >= 0 ? c.Type.split('(')[1].split(')')[0].split(',')[1] : undefined
        this.enum = undefined
        this.deft = c.Default
        this.comm = c.Comment
        this.fkTbl  = undefined
        this.fkCol  = undefined
        this.isPk = c.Key == 'PRI'
        this.isUnsigned = c.Type.indexOf('unsigned') >= 0
        this.isNotNull = c.Null == 'NO'
        this.isNull = false
        this.isUnique = c.Key == 'UNI'
        this.isIncrem = c.Extra.indexOf('auto_increment') >= 0
        this.onUpdate = undefined
        this.onDelete = undefined
        return this.prepare()
    }
    buildMySQL(esc=(name) => name, escId=(name) => name) {
        let s = ``
        s+= this.name                   ? `${escId(this.name)}`        : ``
        s+= this.type                   ? ` ${this.type}`              : ``
        s+= this.sub1 ? this.sub2       ? ` (${this.sub1},`:` (${this.sub1})`:``
        s+= this.sub2                   ? ` ${this.sub2})`             : ``
        s+= this.isUnsigned             ? ` UNSIGNED`                  : ``
        s+= this.enum                   ? ` (${this.enum.map(e => esc(e)).join(', ')})` : ``
        s+= this.deft!==undefined       ? ` DEFAULT ${esc(this.deft)}` : ``
        s+= this.comm                   ? ` COMMENT ${esc(this.comm)}` : ``
        s+= this.isPk                   ? ` PRIMARY KEY`               : ``
        s+= this.isNotNull              ? ` NOT NULL`                  : ``
        s+= this.isNull                 ? ` NULL`                      : ``
        s+= this.isUnique && !this.isPk ? ` UNIQUE`                    : ``
        s+= this.isIncrem               ? ` AUTO INCREMENT`            : ``
        return s
    }
    buildMySQL_fk(esc=(name) => name, escId=(name) => name) {
        let s = ``
        if(!this.fkTbl || !this.fkCol)
            return s
        const fkName = escId(this.fkName? this.fkName : this.fkTbl + '_' + this.fkCol)
        const fkTbl = escId(this.fkTbl)
        const fkCol = escId(this.fkCol)
        s+= ` CONSTRAINT ${fkName}`
        s+= ` FOREIGN KEY (${this.name}) REFERENCES ${fkTbl} (${fkCol})`
        if(this.onDelete)
            s+= ` ON DELETE ${this.onDelete}`
        if(this.onUpdate)
            s+= ` ON UPDATE ${this.onUpdate}`
        return s
    }
    prepareVal(val) {
        if(val === undefined)
            val = this.deft
        if(val === undefined)
            val = null
        if(val === null && this.isNotNull)
            throw `Value for column "${colName}" is required`
        if(this.enum && this.enum.indexOf(val) < 0)
            throw `Value for column "${colName}" does not belong to enum`
        if(this.type == 'BOOLEAN') {
            if(typeof val == 'string')
                val = val.toLowerCase() == 'true' ? true : false
            val = Boolean(val)
        }
        return val
    }
}



// WEBPACK FOOTER //
// ./src/database/Column.js